module.exports = __webpack_public_path__ + "static/media/new-kultur-logo.1c96e826.png";